/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useContext } from 'react';
import PageCenterMsg from './PageCenterMsg';
import { LanguageContext } from './Context';

const SessionExpired = () =>
{
	const { language } = useContext(LanguageContext);
	const handleRefresh = () =>
	{
		window.location.reload();
	};

	return (<PageCenterMsg

		handleButton={handleRefresh} btnAction='true'
	        />);
};

export default SessionExpired;
